// material
import { Box, Container, Typography, Card, useTheme } from "@mui/material";
// components
import Page from "../Page";
import RequestChargerForm from "../requestCharger/RequestChargerForm";

export default function RequestCharger() {
  const theme = useTheme();
  
  return (
    <Page title="Request Charger | ChargeMiles" sx={{ marginTop: { xs: "128px", md: "62px" }, overflow: "hidden", minHeight: '100vh', pb: 10 }}>
      <Container maxWidth="md" sx={{ py: { xs: 3, md: 5 } }}>
        <Card sx={{ 
          boxShadow: (theme) => `0 0 4px 0 rgba(145,158,171,0.24), 0 24px 48px 0 rgba(145,158,171,0.24)`,
          borderRadius: 3,
          overflow: "hidden" 
        }}>
          {/* Header Gradient */}
          <Box
            sx={{
              background: `linear-gradient(135deg, var(--app-color) 0%, ${theme.palette.primary.dark} 100%)`,
              color: '#fff',
              p: { xs: 3, md: 4 },
              textAlign: 'center',
            }}
          >
            <Typography variant="h4" fontWeight={700} gutterBottom>
              Request a Charger
            </Typography>
            <Typography variant="body1" sx={{ opacity: 0.85, maxWidth: 500, mx: 'auto' }}>
              Want a charging station at your location? Let us know your requirements and we will get back to you!
            </Typography>
          </Box>

          <Box sx={{ p: { xs: 3, md: 5 } }}>
            <RequestChargerForm />
          </Box>
        </Card>
      </Container>
    </Page>
  );
}
